module.exports = __webpack_public_path__ + "static/media/beforeFalling.fcd6401f.jpg";